import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { NonProfitOrgType } from '@/api/models/nonProfitOrgModels';
import FormWrapper from '@/components/forms/FormWrapper';
import SalaryForm from '@/components/forms/SalaryForm';
import { SalaryData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateSalary = () => {
  const { salaryDataJson, salaryIndex, type } = useLocalSearchParams<{
    salaryDataJson: string;
    salaryIndex: string;
    type: string;
  }>();
  const [initialSalaryData, setInitialSalaryData] = useState<SalaryData | undefined>(undefined);

  useEffect(() => {
    if (salaryDataJson) {
      const parsedSalary = safeJsonParse<SalaryData>(salaryDataJson);
      if (parsedSalary) setInitialSalaryData(parsedSalary);
    }
  }, [salaryDataJson]);

  return (
    <SafeAreaView style={styles.content} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.container}>
          <SalaryForm
            initialData={initialSalaryData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/edit/npoSalaries',
                params: {
                  salaryDataJson: JSON.stringify(data),
                  salaryIndex: salaryIndex
                }
              });
            }}
            type={type as NonProfitOrgType}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },
  container: {
    flex: 1
  }
});

export default AddUpdateSalary;
